/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

function ContactSection() {
    const { theme } = useTheme();

    return (
        <section
            id="contact"
            className="contact-section"
            style={{
                padding: '100px 0',
                background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.secondary} 100%)`,
                color: '#fff',
                textAlign: 'center'
            }}
        >
            <div className="container">
                <h2 style={{ fontSize: '2.75rem', fontWeight: 800, marginBottom: '20px' }}>
                    Ready to transform?
                </h2>
                <p style={{ fontSize: '1.25rem', marginBottom: '32px', opacity: 0.95 }}>
                    Get in touch with our enterprise experts.
                </p>
                <a
                    href="mailto:info@rudracoresoft.com"
                    style={{
                        color: '#fff',
                        fontWeight: 700,
                        textDecoration: 'none',
                        fontSize: '1.6rem',
                        borderBottom: '3px solid #fff',
                        paddingBottom: '6px',
                        transition: 'opacity 0.2s',
                        display: 'inline-block'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = '0.85'}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                >
                    info@rudracoresoft.com
                </a>
            </div>
        </section>
    );
}

export default ContactSection;
